import axios from 'axios';
import { API_DASHBOARD } from '../../../../../commons/api';
import localStorage from '../../../../../utils/localStorage';

export function getLiveCranesList(selectedAsset, selectedMode) {
  // return [
  //   {
  //     "DeviceAlias": "1_1",
  //     "DeviceCode": "1",
  //     "DeviceName": "ECH",
  //     "Asset": "ECH",
  //     "Longitude1": 55.3756452,
  //     "Latitude1": 25.361688,
  //     "Operating_Stage": "Running"
  //   },
  //   {
  //     "DeviceAlias": "1_2",
  //     "DeviceCode": "2",
  //     "DeviceName": "RS",
  //     "Asset": "RS",
  //     "Operating_Stage": "StandBy",
  //     "Longitude1": 55.380839,
  //     "Latitude1": 25.360952
  //   },
  //   {
  //     "DeviceAlias": "1_3",
  //     "DeviceCode": "3",
  //     "DeviceName": "ITV",
  //     "Asset": "ITV",
  //     "Operating_Stage": "StandBy",
  //     "Longitude1": 55.370667,
  //     "Latitude1": 25.358082
  //   },
  //   {
  //     "DeviceAlias": "1_RTGS1",
  //     "DeviceCode": "RTGS1",
  //     "DeviceName": "RTGS1",
  //     "Asset": "RTGS1",
  //     "Operating_Stage": "StandBy",
  //     "Longitude1": 55.3700426,
  //     "Latitude1": 25.3582665
  //   },
  //   {
  //     "DeviceAlias": "1_QCS1",
  //     "DeviceCode": "QCS1",
  //     "DeviceName": "QCS1",
  //     "Asset": "QCS1",
  //     "Longitude1": 55.3681574,
  //     "Latitude1": 25.3605197,
  //     "Operating_Stage": "Idle"
  //   },
  //   {
  //     "DeviceAlias": "1_MHCS1",
  //     "DeviceCode": "MHCS1",
  //     "DeviceName": "MHCS1",
  //     "Asset": "MHCS1",
  //     "Longitude1": 55.3733398,
  //     "Latitude1": 25.359319,
  //     "Operating_Stage": "StandBy"
  //   },
  //   {
  //     "DeviceAlias": "1_RTGS2",
  //     "DeviceCode": "RTGS2",
  //     "DeviceName": "RTGS2",
  //     "Asset": "RTGS2",
  //     "Longitude1": 55.3720616,
  //     "Latitude1": 25.3581458,
  //     "Operating_Stage": "Running"
  //   },
  //   {
  //     "DeviceAlias": "1_QCS2",
  //     "DeviceCode": "QCS2",
  //     "DeviceName": "QCS2",
  //     "Asset": "QCS2",
  //     "Longitude1": 55.3691308,
  //     "Latitude1": 25.3599393,
  //     "Operating_Stage": "Running"
  //   }
  // ]

  const token = localStorage.get('accessToken');
  const siteId = localStorage.get('currentSite');
  let Authorization = 'Bearer ' + token;
  const getProcessArea = {
    method: 'POST',
    // url: `${API_DEVICE.GetCraneStatus}?SiteId=${siteId}&Module=CHM`,
    url:`${API_DASHBOARD.GetDashboard}?SiteId=${siteId}`,
    headers: {
      Authorization: Authorization
    },
    data: {
      Mode: selectedMode,
      Asset: selectedAsset,
      Name: "Crane Monitoring System",
      PanelName: "Table 2",
      Id: 2,
      SiteId: siteId,
      TimeZone: "Asia/Kolkata"
    }
  };
  return axios(getProcessArea)
    .then((response) => {
      return response.data;
    })
    .catch(() => {
      return [];
    });
}

export function getLiveCraneCountsList() {
  const token = localStorage.get('accessToken');
  const siteId = localStorage.get('currentSite');
  let Authorization = 'Bearer ' + token;
  const getProcessArea = {
    // method: 'GET',
    method:'POST',
    // url: `${API_DEVICE.GetCraneStatusCount}?SiteId=${siteId}&Module=CHM`,
    url:`${API_DASHBOARD.GetDashboard}?SiteId=${siteId}`,
    headers: {
      Authorization: Authorization
    },
    data: {
      Name: "Crane Monitoring System",
      PanelName: "Table",
      Id: 1,
      TimeBucket: "1h",
      SiteId: siteId,
      TimeZone: "Asia/Kolkata",
    }
  };
  return axios(getProcessArea)
    .then((response) => {
      return response.data;
    })
    .catch(() => {
      return [];
    });
  // return [
  //   {
  //     Asset: 'ITV',
  //     Total: 1,
  //     Running: 2,
  //     Idle: 2
  //   },
  //   {
  //     Asset: 'RS',
  //     Total: 1,
  //     Running: 2,
  //     Idle: 2
  //   },
  //   {
  //     Asset: 'ECH',
  //     Total: 1,
  //     Running: 2,
  //     Idle: 2
  //   }
  // ];
}

export function getCraneDetailsByCode(DeviceAlias) {
  const token = localStorage.get('accessToken');
  const siteId = localStorage.get('currentSite');
  let Authorization = 'Bearer ' + token;
  const getProcessArea = {
    method: 'POST',
    url: `${API_DASHBOARD.GetDashboard}?SiteId=${siteId}`,
    headers: {
      Authorization: Authorization
    },
    data: {
      Name: "Crane Monitoring System",
      PanelName	:"Table 3",
      Id: 3,
      SiteId: siteId,
      DeviceAlias:DeviceAlias,
    }
  };
  return axios(getProcessArea)
    .then((response) => {
      return response.data;
    })
    .catch(() => {
      return [];
    });
  // return {
  //   'Vehicle No': 'AP39 DR1987',
  //   'Operating Status': 'Running',
  //   'Engine Speed': '12 Km/h',
  //   'Driver Details': '1234 - Jhon',
  //   'Load/Unload Status': 'Loaded',
  //   Timestamp: '10:10:00',
  //   'Vehicle Speed': 14,
  //   EngineOnTime: '0h 30m',
  //   EngineOffTime: '3h 30m'
  // };
}

export function getTreeData() {
  return [
    {
      title: 'Port Terminal-1',
      key: '0-0',
      children: [
        {
          title: 'Asset On Berth-1',
          key: 'Wood_fuel_equipment',
          children: [
            {
              title: 'ITV',
              key: '0-0-0-0'
            },
            {
              title: 'RS',
              key: '0-0-0-1'
            },
            {
              title: 'ECH',
              key: '0-0-0-2'
            }
          ]
        },
        {
          title: 'Asset On Berth-2',
          key: '0-0-1',
          children: [
            {
              title: 'ITV',
              key: '0-0-1-0'
            },
            {
              title: 'RS',
              key: '0-0-1-1'
            },
            {
              title: 'ECH',
              key: '0-0-1-2'
            }
          ]
        },
        {
          title: 'Asset On Parking/Workshop Area',
          key: '0-0-2',
          children: [
            {
              title: 'ITV',
              key: '0-0-2-0'
            },
            {
              title: 'RS',
              key: '0-0-2-1'
            },
            {
              title: 'ECH',
              key: '0-0-2-2'
            }
          ]
        }
      ]
    }
  ];
}
